import { render, staticRenderFns } from "./HeroThumb.vue?vue&type=template&id=f2bf4c68&scoped=true&"
import script from "./HeroThumb.vue?vue&type=script&lang=js&"
export * from "./HeroThumb.vue?vue&type=script&lang=js&"
import style0 from "./HeroThumb.vue?vue&type=style&index=0&id=f2bf4c68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bf4c68",
  null
  
)

export default component.exports